import React from "react";
import { Mail, Phone, MapPin } from "lucide-react";

const FAQS = [
  ["How long does it take to get solar rooftop subsidy?", "Typically 4-8 weeks post approval and site verification."],
  ["Which discom serves my area?", "PSPCL is the sole distribution utility across Punjab."],
  ["Is Aadhaar mandatory for citizen applications?", "Aadhaar or any valid ID accepted. E-KYC via DigiLocker is fastest."],
  ["Where can I find the latest tender documents?", "The Tenders section always lists open, closed and awarded tenders."],
];

export default function ContactPage() {
  return (
    <div className="container-x py-12">
      <div className="label-tiny text-[hsl(var(--primary))]">Contact</div>
      <h1 className="mt-1 text-3xl lg:text-5xl font-heading font-bold">Reach us</h1>
      <div className="mt-8 grid lg:grid-cols-3 gap-6">
        {[
          { icon: MapPin, title: "Office",  v: "Plot No. 1-2, Sector 33-D, Chandigarh 160034" },
          { icon: Phone,  title: "Call",    v: "+91-172-2663328 / 2663329" },
          { icon: Mail,   title: "Email",   v: "info@peda.gov.in" },
        ].map((c) => (
          <div key={c.title} className="rounded-xl border border-border p-6 bg-card">
            <div className="h-11 w-11 rounded-lg bg-[hsl(var(--primary))]/10 text-[hsl(var(--primary))] grid place-items-center"><c.icon className="h-5 w-5"/></div>
            <div className="mt-4 label-tiny">{c.title}</div>
            <div className="mt-1 font-medium">{c.v}</div>
          </div>
        ))}
      </div>
      <section id="faq" className="mt-14">
        <div className="label-tiny text-[hsl(var(--accent))]">FAQs</div>
        <h2 className="mt-1 text-3xl font-heading font-bold">Frequently asked</h2>
        <div className="mt-6 space-y-3">
          {FAQS.map(([q, a], i) => (
            <details key={i} className="rounded-xl border border-border bg-card p-5">
              <summary className="cursor-pointer font-medium">{q}</summary>
              <p className="mt-2 text-sm text-muted-foreground">{a}</p>
            </details>
          ))}
        </div>
      </section>
    </div>
  );
}
